import React from 'react'

const IconSvg = () => (
  <svg
    width='50'
    height='50'
    viewBox='0 0 50 50'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g opacity='0.25'>
      <path
        d='M27.0859 6.25C16.7318 6.25 8.33594 14.6458 8.33594 25H2.08594L10.1901 33.1042L10.3359 33.3958L18.7526 25H12.5026C12.5026 16.9375 19.0234 10.4167 27.0859 10.4167C35.1484 10.4167 41.6693 16.9375 41.6693 25C41.6693 33.0625 35.1484 39.5833 27.0859 39.5833C23.0651 39.5833 19.4193 37.9375 16.7943 35.2917L13.8359 38.25C17.2318 41.6458 21.8984 43.75 27.0859 43.75C37.4401 43.75 45.8359 35.3542 45.8359 25C45.8359 14.6458 37.4401 6.25 27.0859 6.25ZM25.0026 16.6667V27.0833L33.9193 32.375L35.4193 29.8542L28.1276 25.5208V16.6667H25.0026Z'
        fill='#1B1B1D'
      />
    </g>
  </svg>
)

export default IconSvg
